module.exports = __webpack_public_path__ + "static/media/jobfunktionkurser.ab72e619.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Courses/jobfunktionkurser.jpg
// module id = 1526
// module chunks = 0